module.exports = globalThis["crateImports"]["react-dom"];